export const assistantKeys = {
  all: ['assistant'] as const,
  /**
   * `pageUrl` scoping is optional for backward compatibility: panels that do
   * not pass it keep the historical shared key, while the survey-studio panel
   * keys its authoring thread (CONSULTANT workspace) separately from any
   * active-tenant thread.
   */
  thread: (pageUrl?: string) =>
    pageUrl
      ? ([...assistantKeys.all, 'thread', pageUrl] as const)
      : [...assistantKeys.all, 'thread'],
};
